/**
 * 操作ログのフィルター・ラベル定義
 */

// アクションの種類
export const ACTION_OPTIONS = [
  { value: "LOGIN", label: "ログイン" },
  { value: "REPROCESS_LOG", label: "再処理実行" },
  { value: "CREATE_CUSTOMER", label: "顧客作成" },
  { value: "UPDATE_CUSTOMER", label: "顧客更新" },
  { value: "DELETE_CUSTOMER", label: "顧客削除" },
  { value: "CREATE_CSV_TEMPLATE", label: "テンプレート作成" },
  { value: "UPDATE_CSV_TEMPLATE", label: "テンプレート更新" },
  { value: "DELETE_CSV_TEMPLATE", label: "テンプレート削除" },
  { value: "CREATE_ADMIN", label: "管理者作成" },
  { value: "UPDATE_ADMIN_ROLE", label: "権限更新" },
  { value: "DELETE_ADMIN", label: "管理者削除" },
];

// リソースの種類
export const RESOURCE_OPTIONS = [
  { value: "auth", label: "認証" },
  { value: "log", label: "処理ログ" },
  { value: "customer", label: "顧客" },
  { value: "csv_template", label: "CSVテンプレート" },
  { value: "admin", label: "管理者" },
  { value: "customer_settings", label: "顧客詳細設定" },
];

/**
 * アクションの色を取得
 */
export function getActionColor(action: string): string {
  if (action.startsWith("CREATE")) return "blue";
  if (action.startsWith("UPDATE")) return "orange";
  if (action.startsWith("DELETE")) return "red";
  if (action === "LOGIN") return "cyan";
  return "gray";
}

/**
 * アクションのラベルを取得
 */
export function getActionLabel(action: string): string {
  // 1. 完全一致（定義リスト）
  const matched = ACTION_OPTIONS.find((opt) => opt.value === action);
  if (matched) return matched.label;

  // 2. 一般的な動詞のマッピング
  const a = action.toLowerCase();
  if (a === "login") return "ログイン";
  if (a === "reprocess" || a === "reprocess_log") return "再処理";
  if (a.includes("create")) return "作成";
  if (a.includes("update")) return "更新";
  if (a.includes("delete")) return "削除";

  return action;
}

/**
 * リソースのラベルを取得
 */
export function getResourceLabel(type: string): string {
  // 1. 完全一致
  const matched = RESOURCE_OPTIONS.find((opt) => opt.value === type);
  if (matched) return matched.label;

  // 2. シードデータ等のバリエーション対応
  const t = type.toLowerCase();
  if (t === "template") return "テンプレート";
  if (t === "admin") return "管理者";
  if (t === "log") return "処理ログ";

  return type;
}
